(function () {
  const header = document.querySelector('.ppt-header');
  const form = header && header.querySelector('.ppt-search');
  const input = form && form.querySelector('input[name="q"]');
  if (!input || form.dataset.predictiveReady) return;
  form.dataset.predictiveReady = '1';
  const trigger = header.querySelector('.ppt-searchmobile');
  const results = document.createElement('div');
  results.className = 'ppt-search-results';
  results.id = 'PptSearchSuggestions';
  results.hidden = true;
  results.setAttribute('role', 'dialog');
  results.setAttribute('aria-label', 'Sugerencias de búsqueda');
  form.appendChild(results);
  input.setAttribute('autocomplete', 'off');
  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-haspopup', 'dialog');
  input.setAttribute('aria-controls', results.id);
  input.setAttribute('aria-expanded', 'false');
  let timer, controller, generation = 0;
  form.addEventListener('submit', e => {
    if (!input.value.trim()) { e.preventDefault(); input.focus(); }
  });
  function close() { generation++; clearTimeout(timer); if (controller) controller.abort(); results.hidden = true; input.setAttribute('aria-expanded', 'false'); }
  function status(text, loading) {
    results.replaceChildren();
    const p = document.createElement('p');
    p.setAttribute('role', 'status');
    if (loading) p.className = 'ppt-search-loading';
    p.textContent = text;
    results.appendChild(p);
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }
  function link(title, url) {
    const parsed = new URL(url, location.origin);
    if (parsed.origin !== location.origin) return;
    const a = document.createElement('a');
    a.href = parsed.pathname + parsed.search;
    a.textContent = title;
    results.appendChild(a);
    return a;
  }
  // El resaltado viene del servicio ya escapado y con <mark>. Se arma con
  // nodos de texto y <mark> reales: nada más del string llega como HTML.
  function marked(a, html) {
    a.replaceChildren();
    const decode = document.createElement('textarea');
    String(html).split(/(<mark>|<\/mark>)/).reduce((inMark, part) => {
      if (part === '<mark>') return true;
      if (part === '</mark>') return false;
      if (!part) return inMark;
      decode.innerHTML = part;
      const text = document.createTextNode(decode.value);
      if (inMark) { const m = document.createElement('mark'); m.appendChild(text); a.appendChild(m); } else a.appendChild(text);
      return inMark;
    }, false);
  }
  const root = () => window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const searchUrl = q => form.action + '?q=' + encodeURIComponent(q);
  const config = window.PPT_SEARCH || {};
  // pluspet-search (Elasticsearch). Vacío = búsqueda nativa de Shopify.
  async function fromService(query, signal) {
    const timeout = new AbortController();
    const abort = () => timeout.abort();
    signal.addEventListener('abort', abort);
    const timer = setTimeout(abort, 1500);
    try {
      const params = new URLSearchParams({shop: config.shop || '', q: query});
      const response = await fetch(config.url.replace(/\/$/, '') + '/v1/suggest?' + params, {signal: timeout.signal, headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('search service');
      return await response.json();
    } finally { clearTimeout(timer); signal.removeEventListener('abort', abort); }
  }
  function renderService(data, query) {
    results.replaceChildren();
    const products = data.products || [], collections = data.collections || [], queries = data.queries || [];
    if (!products.length && !collections.length) {
      if (data.correction) {
        const a = link('¿Quisiste decir ' + data.correction + '?', searchUrl(data.correction));
        if (a) a.dataset.correction = '1';
      } else status('No encontramos sugerencias. Podés buscar en todo el catálogo.');
    }
    products.forEach(p => { const a = link(p.title, root() + 'products/' + encodeURIComponent(p.handle)); if (a && p.highlight) marked(a, p.highlight); });
    collections.forEach(c => link(c.title, root() + 'collections/' + encodeURIComponent(c.handle)));
    queries.forEach(q => { const a = link(q, searchUrl(q)); if (a) a.dataset.query = '1'; });
    link('Ver todos los resultados', searchUrl(query));
  }
  input.addEventListener('input', () => {
    close();
    const query = input.value.trim();
    if (query.length < 2) return;
    const run = generation;
    status('Buscando…', true);
    timer = setTimeout(async () => {
      controller = new AbortController();
      if (config.url) {
        try {
          const data = await fromService(query, controller.signal);
          if (run !== generation) return;
          renderService(data, query);
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          return;
        } catch (error) {
          // Servicio caído, lento o una tienda que no conoce: sigue la nativa.
          if (run !== generation || controller.signal.aborted) return;
        }
      }
      try {
        const params = new URLSearchParams({q:query,'resources[type]':'product,collection','resources[limit]':'6','resources[options][unavailable_products]':'last'});
        const response = await fetch(root() + 'search/suggest.json?' + params, {signal:controller.signal,headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('search');
        const data = await response.json();
        if (run !== generation) return;
        const found = data.resources && data.resources.results || {};
        results.replaceChildren();
        const products = found.products || [], collections = found.collections || [];
        if (!products.length && !collections.length) status('No encontramos sugerencias. Podés buscar en todo el catálogo.');
        products.forEach(p => link(p.title, p.url));
        collections.forEach(c => link(c.title, c.url));
        link('Ver todos los resultados', form.action + '?q=' + encodeURIComponent(query));
      } catch (error) {
        if (run !== generation || error.name === 'AbortError') return;
        status('No pudimos cargar sugerencias.');
        link('Buscar en el catálogo', form.action + '?q=' + encodeURIComponent(query));
      }
    }, 200);
  });
  if (trigger) trigger.addEventListener('click', e => {
    e.preventDefault();
    const open = !header.classList.contains('is-search-open');
    header.classList.toggle('is-search-open', open);
    trigger.setAttribute('aria-expanded', String(open));
    if (open) { header.classList.remove('is-hidden'); input.focus(); } else close();
  });
  document.addEventListener('click', e => { if (!form.contains(e.target) && !(trigger && trigger.contains(e.target))) close(); });
  form.addEventListener('keydown', e => {
    if (e.key === 'Escape') { close(); header.classList.remove('is-search-open'); if (trigger && getComputedStyle(trigger).display !== 'none') trigger.focus(); return; }
    const links = [...results.querySelectorAll('a')];
    if (!results.hidden && links.length && ['ArrowDown','ArrowUp'].includes(e.key)) {
      e.preventDefault();
      const current = links.indexOf(document.activeElement);
      links[(current + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
    }
  });
})();
